import { MAINURL, TESTURL } from '@/config/index';
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios'
import { Message, Loading } from 'element-ui';

declare type Methods = "GET" | "OPTIONS" | "HEAD" | "POST" | "PUT" | "DELETE" | "TRACE" | "CONNECT"
declare interface Datas {
    method?: Methods
    [key: string]: any
}
const baseUrl = process.env.NODE_ENV === 'production' ? MAINURL : TESTURL

// 失败回调
const requestFail = (res: any) => {
    const errStr = '网络繁忙或者系统内部错误!'
    Message({
        showClose: true,
        message: res.data.message || errStr,
        type: 'error'
    });
    return {
        err: console.error(res),
        ...res.data
    }
}
const defaultConfig: object = {
    baseURL: baseUrl,
    timeout: 180000
}
class HttpRequest {
    public quene: any
    public loading: any
    public constructor() {
        this.quene = {}
        this.loading = null
    }
    public async request(options: any, isOpenInterceptor: boolean = true) {
        const instance = axios.create({ ...defaultConfig });
        const methodStr: string = 'method'
        const paramsStr: string = 'params'
        if (!options[methodStr]) {
            if (!options[paramsStr]) {
                Object.assign(options, {
                    params: {
                        timestamp: new Date().getTime()
                    }
                })
            } else {
                Object.assign(options.params, {
                    timestamp: new Date().getTime()
                })
            }
        }
        if (isOpenInterceptor) {
            await this.interceptors(instance, options.url as string)
        }
        return instance(options)
    }
    private destroy(url: string) {
        delete this.quene[url]
        if (!Object.keys(this.quene).length) {
            // 隐藏loading
        }
    }
    private interceptors(instance: any, url: string) {
        // 请求拦截
        instance.interceptors.request.use((config: any) => {
            if (!Object.keys(this.quene).length) {
                // 全局loading
                this.loading = Loading.service({
                    lock: true,
                    text: '拼命加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.2)'
                });
            }
            if (url) {
                this.quene[url] = true
            }
            let userAccount:String = sessionStorage.getItem('userToken') ? JSON.parse((sessionStorage.getItem('userToken') as string)).userAccount : '' || ''
            config.headers['userAccount'] = userAccount
            config.headers['token'] = sessionStorage.getItem('token') || ''
            // userAccount
            return config
        }, (error: any) => {
            console.error(error)
        })
        // 响应拦截
        instance.interceptors.response.use((res: any) => {
            if (url) {
                this.destroy(url)
            }
            const { data, status } = res
            if (this.loading) {
                this.loading.close();
            }
            if (status === 200 && data && data.code === 200 && data.success) {
                return data
            }
            return requestFail(res) // 失败回调
        }, (error: any) => {
            if (url) {
                this.destroy(url)
            }
            Message({
                showClose: true,
                message: '请求失败!',
                type: 'error'
            });
            if (this.loading) {
                this.loading.close();
            }
            console.error(error);
            // Toast.fail(error);
        })
    }


}
const http = new HttpRequest();

const Axios = async (options: any, isOpenInterceptor: boolean = true) => {
    return http.request(options, isOpenInterceptor)
}

export default Axios


